import {
  createProductByVendor,
  updateProductByVendor,
  getAllProductsByVendor,
  createProductByAdmin,
  updateProductByAdmin,
  getAllProductsByAdmin,
  reviewProduct,
  getInventoryByVendor,
  updateProductStock,
} from "services/productService";
import {
  getProductsStart,
  getProductsSuccess,
  getProductsFailure,
  createProductStart,
  createProductSuccess,
  createProductFailure,
  updateProductStart,
  updateProductSuccess,
  updateProductFailure,
  getInventoryStart,
  getInventorySuccess,
  getInventoryFailure,
  updateStockStart,
  updateStockSuccess,
  updateStockFailure,

  //By Admin
  getProductsByAdminStart,
  getProductsByAdminSuccess,
  getProductsByAdminFailure,
  createProductByAdminStart,
  createProductByAdminSuccess,
  createProductByAdminFailure,
  updateProductByAdminStart,
  updateProductByAdminSuccess,
  updateProductByAdminFailure,
  updateProductApprovalStart,
  updateProductApprovalSuccess,
  updateProductApprovalFailure,

} from "store/features/product/productSlice";
import { showErrorToast } from "utils/toastNotification";
import { showSuccessToast } from "utils/toastNotification";

// **************************************PRODUCT MANAGEMENT BY VENDOR*********************************

export const fetchAllProducts = () => async (dispatch) => {
  try {
    dispatch(getProductsStart());
    const response = await getAllProductsByVendor();
    dispatch(getProductsSuccess(response.data));
  } catch (error) {
    dispatch(getProductsFailure(error.message));
  }
};

export const createNewProduct = (productData) => async (dispatch) => {
  try {
    dispatch(createProductStart());
    const response = await createProductByVendor(productData);
    dispatch(createProductSuccess(response.data));
  } catch (error) {
    dispatch(createProductFailure(error.message));
  }
};

export const updateExistingProduct =
  (productId, updateData) => async (dispatch) => {
    try {
      dispatch(updateProductStart());
      const response = await updateProductByVendor(productId, updateData);
      dispatch(updateProductSuccess(response.data));
    } catch (error) {
      dispatch(updateProductFailure(error.message));
    }
  };

// Inventory management by vendor
export const fetchInventoryByVendor = () => async (dispatch) => {
  try {
    dispatch(getInventoryStart());
    const response = await getInventoryByVendor();
    dispatch(getInventorySuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getInventoryFailure(error.message));
    throw error;
  }
};

export const updateProductStockAction =
  (productId, stock) => async (dispatch) => {
    try {
      dispatch(updateStockStart());
      const response = await updateProductStock(productId, stock);
      dispatch(updateStockSuccess(response.data));
      return response;
    } catch (error) {
      dispatch(updateStockFailure(error.message));
      showErrorToast(error.message || "Failed to update stock");
      throw error;
    }
  };

// **************************************PRODUCT MANAGEMENT BY ADMIN*********************************

export const fetchAllProductsByAdmin = () => async (dispatch) => {
  try {
    dispatch(getProductsByAdminStart());
    const response = await getAllProductsByAdmin();
    dispatch(getProductsByAdminSuccess(response.data));
  } catch (error) {
    dispatch(getProductsByAdminFailure(error.message));
  }
};


export const createNewProductByAdmin = (productData) => async (dispatch) => {
  try {
    dispatch(createProductByAdminStart());
    const response = await createProductByAdmin(productData);
    dispatch(createProductByAdminSuccess(response.data));
  } catch (error) {
    dispatch(createProductByAdminFailure(error.message));
  }
};

export const updateExistingProductByAdmin =
  (productId, updateData) => async (dispatch) => {
    try {
      dispatch(updateProductByAdminStart());
      const response = await updateProductByAdmin(productId, updateData);
      dispatch(updateProductByAdminSuccess(response.data));
    } catch (error) {
      dispatch(updateProductByAdminFailure(error.message));
    }
  };

export const productReviewApprovalAction =
  (productId, status) => async (dispatch) => {
    try {
      dispatch(updateProductApprovalStart());
      const response = await reviewProduct(productId, status);
      dispatch(updateProductApprovalSuccess(response.data));
      if (response.data.status === "approved") {
        showSuccessToast("Product approved successfully");
      } else {
        showErrorToast("Product approval revoked");
      }
    } catch (error) {
      dispatch(updateProductApprovalFailure(error.message));
      showErrorToast(error.message || "Failed to update vendor approval");
    }
  };
